export default "__VITE_ASSET__BbM7Se$k__"